import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      primaryAccount: 'permissions/isPrimaryAccount',
      currentBranchId: 'branches/currentBranchId',
      isDark: 'appConfig/isDark',
      isRTL: 'appConfig/isRTL',
    }),
  },
}
